import { inject, Injectable, Signal } from '@angular/core';
import { UserAccount, UserPreferences } from '@iot-platform/models/common';
import { Store } from '@ngrx/store';
import { PreferencesActions, ProfileActions } from '../actions';
import * as fromUsers from '../reducers';

@Injectable({
  providedIn: 'root'
})
export class ProfileFacade {
  private readonly store: Store = inject(Store);

  user: Signal<UserAccount> = this.store.selectSignal(fromUsers.getCurrentProfileUser);
  userPreferences: Signal<UserPreferences> = this.store.selectSignal(fromUsers.getPreferences);
  userLoading: Signal<boolean> = this.store.selectSignal(fromUsers.getUserProfileLoading);

  loadUserProfile(): void {
    this.store.dispatch(ProfileActions.loadUserProfile());
  }

  loadUserPreferences(): void {
    this.store.dispatch(PreferencesActions.loadUserPreferences());
  }

  saveUserProfile(payload: Partial<UserAccount>): void {
    this.store.dispatch(ProfileActions.saveUserProfile({ payload }));
  }
}
